//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../no/Builder.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
import "../no/Expression.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[1,"AdditionalReferences",0,"Assemblies.SelectComponentList",0],[0,"Associative",1,0],[0,"Characteristics",0,"Weld.CharacteristicsBuilder",0],[0,"ControlMethod",1,0],[0,"CreateDirectionVector",1,0],[0,"CreatePlane",1,0],[0,"CreatePoint",1,0],[0,"CreationDirection",1,0],[0,"CustomAboveLength",1,0],[0,"CustomRadius",1,0],[0,"CustomTotalLength",1,0],[0,"CustomType",1,0],[0,"CustomTypeName",1,0],[0,"Derived",1,0],[0,"DerivedParentID",1,0],[0,"DirectionAxis",1,"Axis",0],[0,"DirectionLength",1,0],[0,"HoleDiameter",1,0],[0,"ModelingTolerance",1,0],[0,"PlaneHeight",1,0],[0,"PlaneMethod",1,0],[0,"PlaneWidth",1,0],[0,"PrincipalAxisX",1,0],[0,"PrincipalAxisY",1,0],[0,"PrincipalAxisZ",1,0],[0,"ProjectAlongDirection",1,0],[1,"RadiusExp",0,"Expression",0],[1,"RotationAngle",0,"Expression",0],[0,"SectionPlaneNormal",1,"Direction",0],[0,"SizeMethodType",1,0],[0,"SlotLength",1,0],[0,"SlotWidth",1,0],[0,"SolidType",1,0],[1,"UserPlane",0,"SelectNXObjectList",0],[0,"XTolerance",1,0],[0,"YTolerance",1,0],[0,"ZTolerance",1,0]],[[[],"UpdateWithDerivedDatum",{},0,0]],[]];
SPLM.Weld.DatumCommonBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.DatumCommonBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Weld.DatumCommonBuilder.CustomTypes = Object.freeze({
    "Default" : "Default", "Custom1" : "Custom1", "Custom2" : "Custom2", "Custom3" : "Custom3", "Custom4" : "Custom4", "Custom5" : "Custom5", "Custom6" : "Custom6", "Custom7" : "Custom7"});

SPLM.Weld.DatumCommonBuilder.ControlMethodTypes = Object.freeze({
    "PrincipalAxis" : "PrincipalAxis", "UseSectionPlane" : "UseSectionPlane"});

SPLM.Weld.DatumCommonBuilder.SolidTypes = Object.freeze({
    "Sphere" : "Sphere", "Cylinder" : "Cylinder", "Cone" : "Cone", "Cuboid" : "Cuboid", "Hollow" : "Hollow", "Arrow" : "Arrow", "None" : "None", "Hourglass" : "Hourglass"});

SPLM.Weld.DatumCommonBuilder.CreationDirectionMethods = Object.freeze({
    "Default" : "Default", "Opposite" : "Opposite"});

SPLM.Weld.DatumCommonBuilder.SizeMethodTypes = Object.freeze({
    "Automatic" : "Automatic", "Manual" : "Manual"});

SPLM.Weld.DatumCommonBuilder.PlaneMethodTypes = Object.freeze({
    "InferPlanes" : "InferPlanes", "ParallelXCPlanes" : "ParallelXCPlanes", "ParallelYCPlanes" : "ParallelYCPlanes", "ParallelZCPlanes" : "ParallelZCPlanes", "SelectPlanes" : "SelectPlanes", "Unknown" : "Unknown"});

export default SPLM;